"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_TAGS = void 0;
const TEXT_TAGS = exports.TEXT_TAGS = ['span', 'p', 'b', 'strong', 'i', 'em', 'pre', 'code', 'div'];